import React, { Component, PropTypes } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Project from '../components/Project';
const { Link } = require('react-router')

import { connect } from 'react-redux';

//Change Class per Project
class Volkno extends React.Component {
  render () {
    const { projects, benchmark, personalInfo } = this.props;  
    console.log(personalInfo);
    
    const featProject = projects[0];

    // const params = this.props.params || {}
    // const { title, description, year, poster, trailer } = params
    return (
      <div className='main-app-container'>
        <Header personalInfo={personalInfo} />
        <div className=''>
          <div className='back-button'>
          <Link to='/'>
          <span className="glyphicon glyphicon-chevron-left"></span>
            Back to projects
          </Link>
          </div>
          <Project project={featProject}/>


        </div>

        <div className='case-study col-md-12 col-xs-12'>
        <h4>Overview</h4>

        <p>
        <a href="http://volkno.com">Volkno</a> is a web application that uses advanced sampling and machine learning to draw predictions from consumer feedback.
        The projects I worked on included a custom video CMS that allowed clients to upload content, and specify the type of target audience and focus test.
        This would directly feed to a cross-platform consumer application that allowed users to submit feedback during 
        a playing video and earn points to later be redeemed.  

        </p>

        <p>
        After getting the appropriate user feedback, clients would have access to a custom analytics portal, insights and predictions.


        </p>

        <p>
     
        </p>  
        <p>
        Below are a couple issues I was able to work though in development, hopefully these can help other developers running into the same problems.
        </p>


        <h4>
        Dealing with pesky UI elements and javascript sprawl.  
        </h4>


        <p>
        When you are dealing with files containing 3000+ lines of javascript, being worked on by multiple people, sometimes hide and show methods are written redundantly.
        </p>


        <p>
        So, two different functions may hide and show the same element, causing it to flash on the screen for a second.
        </p>


        <p>
        A good way to get around this is to use: 
        </p>




        <pre>{`
        .is(':visible') to check and see if the element is currently on screen or not.


        if($('#testElement').is(':visible')) { //then hide the element }

          `}</pre> 


        <h4>
        Using an API that is under development
        </h4>


        <p>
        Using a default case to can help keep an interface from breaking when using a custom API that is continuously being developed on. 
        </p>


        <pre>{`

        case 500: 
                        console.log("Error! Whups.");
                        break;


         default:
                        console.log("GET PROFILE DATA. in default catch for switch on response status");
                        break;
                }

          `}</pre>


        <h4>
        Working with UI Mobile Web View
        </h4>


        <p>
        If you want to quickly iterate and test an interface for a native app it is possible to create a native iOS application with Swift that just displays your webpage in a IOS UI Mobile wrapper.
        </p>


        <p>
        The pros are rapid development and the ability to push changes directly to the production app multiple times a day.
        </p>


        <p>
        The cons include a 300ms tap delay, and having to debug a UI without the use of a developer console. 
        </p>


        <p>
        There are plenty of libraries that solve the tap delay problem, we liked interact.js
        </p>


        <h4>
        iOS UI Web View - Edge Cases
        </h4>
        <p>
        We had an issue with an unclosed {'<div>'}' tag completely breaking the page on one part of the application.  Since there were no visible errors in the Chrome dev console, I didn’t have much to go on in terms of debugging.  
        </p>


        <p>
        After spending hours tracing through javascript, I finally noticed it within the page html.
        </p>


        <p>
        This could have been avoided by using a <a href='https://github.com/facelessuser/BracketHighlighter
        '>sublime text bracket highlighter.</a>  Its a plugin that highlights the closing tags in your code editor.  

        Also this would never happen using React and since it will throw an error for unclosed JSX tags. 
        </p>





        </div>
        <Footer personalInfo={personalInfo} />
      </div>
    )
  }
}

const { object, array } = React.PropTypes

Volkno.propTypes = {
  projects: PropTypes.array.isRequired,
  personalInfo: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    projects: state.projects,
    personalInfo: state.personalInfo
  };
}

//Change for each project

export default connect(mapStateToProps)(Volkno)




/** WEBPACK FOOTER **
 ** ./src/pages/Volkno.js
 **/